<template>
  <div id="app" :style="{height:windowsHeight +'px'}">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowsHeight: 0
    };
  },
  mounted() {
    this.windowsHeight =
      document.body.clientHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;
  }
};
</script>
<style>
</style>





// WEBPACK FOOTER //
// src/App.vue